import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useState, useEffect } from "react";
import Button from "../base/Button";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import CustomSearch from "../base/CustomSearch";

function SOP_Policies_Categories() {
  const [permissions, setPermissions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  useEffect(() => {
    const pers = getPermissions();
    if (pers) setPermissions(pers);
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchSOPPoliciesCategory();
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [pagination.currentPage, pagination.perPage, searchTerm]);

  // handle fetch
  const fetchSOPPoliciesCategory = async () => {
    try {
      const params = {
        page: pagination.currentPage,
        perPage: pagination.perPage,
      };
      if (searchTerm.trim()) {
        params.search = searchTerm.trim();
      }
      setLoading(true);
      const response = await apiUrl.get("/sop-policies/categories", { params });
      setCategories(response?.data?.data);
      setPagination((prev) => ({
        ...prev,
        total: response?.data?.pagination?.total,
        lastPage: response?.data?.pagination?.lastPage,
        currentPage: response?.data?.pagination?.currentPage,
      }));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  // handle edit category
  const handleEditClick = (cat) => {
    setEdit(true);
    setEditId(cat.id);
    setCategoryName(cat.name);
    setCategoryDescription(cat.description || "");
    setOpenModal(true);
  };
  //   handle save category
  const handleSaveCategory = async () => {
    let newErrors = {};

    if (!categoryName.trim()) {
      newErrors.categoryName = "Category name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoadingButton(true);

    try {
      let response;

      if (editId) {
        response = await apiUrl.post(`/edit-policies/categories/${editId}`, {
          name: categoryName,
          description: categoryDescription,
        });
      } else {
        response = await apiUrl.post("/sop-policies/categories", {
          name: categoryName,
          description: categoryDescription,
        });
      }

      Swal.fire({
        title: response.data.message,
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
      });

      setCategoryName("");
      setCategoryDescription("");
      setEdit(false);
      setEditId(null);
      setOpenModal(false);

      fetchSOPPoliciesCategory();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };
  //   handle delete SOP and Policies
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.delete(
            `/deleteSOPPolicyCategory/${id}`,
          );
          if (response?.data?.status) {
            Swal.fire({
              title: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              showConfirmButton: false,
              position: "top-end",
            });
            fetchSOPPoliciesCategory();
          }
        } catch (error) {
          Swal.fire({
            title: error.response?.data?.message || "Error deleting department",
            icon: "error",
            timer: 3000,
            toast: true,
            showConfirmButton: false,
            position: "top-end",
          });
        }
      }
    });
  };
  return (
    <>
      {permissions?.upload_sop_and_policies && (
        <div className="card px-4 py-3 bg-white ">
          <header className="mb-5">
            <div className="flex items-center justify-between flex-wrap">
              <div>
                <h1 className="h3 fw-bold">SOP & Policies Categories</h1>
                <p className="text-muted small">
                  Mangage SOP & Policies categories here
                </p>
              </div>
              <div>
                <Button
                  text="Add Category"
                  size="md"
                  variant="primary"
                  onClick={() => {
                    setOpenModal(true);
                    setCategoryName("");
                    setCategoryDescription("");
                  }}
                />
              </div>
            </div>
          </header>

          <div className="flex items-center justify-between mb-2">
            <h1 className="h4 font-semibold">Search SOP Policy Category</h1>
            <CustomSearch
              placeholder="Search SOP Policy..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onClear={() => {
                setSearchTerm("");
              }}
            />
          </div>

          {/* modal for create and edit */}
          {openModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
                onClick={() => setOpenModal(false)}
              />
              <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
                style={{ zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-lg"
                  style={{ maxWidth: 700 }}
                >
                  <div
                    className="modal-content border-0 rounded-4 shadow"
                    style={{ overflow: "hidden" }}
                  >
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <div>
                        {edit ? (
                          <h5
                            className="modal-title"
                            style={{ fontWeight: 700 }}
                          >
                            Edit SOP & Policies Category
                          </h5>
                        ) : (
                          <h5
                            className="modal-title"
                            style={{ fontWeight: 700 }}
                          >
                            Add SOP & Policies Category
                          </h5>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                      />
                    </div>
                    <div className="modal-body p-4">
                      <div className="mb-3">
                        <label htmlFor="categoryName" className="form-label">
                          Category Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.categoryName ? "is-invalid" : ""}`}
                          id="categoryName"
                          value={categoryName}
                          onChange={(e) => {
                            setCategoryName(e.target.value);
                            setErrors({ ...errors, categoryName: "" });
                          }}
                          placeholder="Policies"
                        />
                        {errors.categoryName && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "14px" }}
                          >
                            {errors.categoryName}
                          </div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="categoryDescription"
                          className="form-label"
                        >
                          Category Description
                        </label>
                        <textarea
                          className="form-control"
                          id="categoryDescription"
                          value={categoryDescription}
                          onChange={(e) =>
                            setCategoryDescription(e.target.value)
                          }
                          placeholder="Company policies and procedures"
                          rows={4}
                        />
                      </div>
                    </div>

                    {/* Footer actions */}
                    <div
                      className="modal-footer"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setOpenModal(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={handleSaveCategory}
                        disabled={loadingButton}
                      >
                        {loadingButton ? "Saving..." : edit ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* table */}
          <table className="table w-full">
            <thead>
              <tr>
                <th>Category Name</th>
                <th>Description</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {/* ---------- SKELETON (DaisyUI style) ---------- */}
              {loading ? (
                <>
                  {[...Array(3)].map((_, i) => (
                    <tr key={i}>
                      {/* Category Name */}
                      <td className="py-3">
                        <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="py-3">
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-4 bg-gray-300 rounded-full animate-pulse"></div>
                        </div>
                      </td>
                      {/* Created At */}
                      <td className="py-3">
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-4 bg-gray-300 rounded animate-pulse"></div>
                          <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                      {/* Actions */}
                      <td className="py-3 text-right pr-6">
                        <div className="flex justify-end gap-2">
                          <div className="h-8 w-16 bg-gray-300 rounded animate-pulse"></div>
                          <div className="h-8 w-16 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              ) : categories?.length === 0 ? (
                <tr>
                  <td
                    colSpan={4}
                    className="text-center py-6 text-base-content/60"
                  >
                    No SOP Policies categories found.
                  </td>
                </tr>
              ) : (
                categories?.map((cat) => (
                  <tr key={cat?.id}>
                    <td>{cat?.name}</td>

                    <td className="max-w-xs whitespace-normal break-words">
                      {cat?.description ? cat?.description : "-"}
                    </td>

                    <td>{new Date(cat?.created_at).toLocaleDateString()}</td>

                    <td>
                      <div className="flex gap-2">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleEditClick(cat)}
                        >
                          Edit
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(cat.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* pagination */}
          <div className="row align-items-center mb-5 mt-2">
            <div className="col-auto">
              <select
                value={pagination?.perPage}
                onChange={handlePerPageChange}
                className="form-select"
                style={{ minWidth: 80 }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
            <div className="col-auto text-muted">
              Page {pagination.currentPage} – Showing{" "}
              {Math.min(
                pagination.perPage,
                pagination.total -
                  (pagination.currentPage - 1) * pagination.perPage,
              )}{" "}
              of {pagination.total} entries
            </div>
            <div className="col">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination justify-content-end mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SOP_Policies_Categories;
